// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Select from "react-select";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { unitInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const UnitNew = ({ title }) => {
//   // const [file, setFile] = useState("");
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//   };
//   const navigate = useNavigate();
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("name", inputValues.name);
//     formData.append("month", inputValues.month);
//     formData.append("description", inputValues.description);
//     formData.append("chapter_id", localStorage.getItem("chapter_id_for_unit"));
//     formData.append("status", inputValues.status || 0);
//     // formData.append("logo", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_unit`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         // setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Unit added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/teacher/course-chapter/unit");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const showNotification = (message) => {
//     setNotification(message);
//     setIsNotificationVisible(true);

//     // Automatically hide the notification after a certain time (e.g., 3 seconds)
//     setTimeout(() => {
//       setIsNotificationVisible(false);
//       setNotification("");
//     }, 3000); // Adjust the time as needed
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         file
//                                     }
//                                     alt=""
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {/* <div className="formInput">
//                                         <label htmlFor="file">
//                                             Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                                         </label>
//                                         <input
//                                             type="file"
//                                             id="file"
//                                             onChange={(e) => setFile(e.target.files[0])}
//                                             style={{ display: "none" }}
//                                         />
//                                     </div> */}
//                   {unitInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           {
//                             <input
//                               type={input.type}
//                               placeholder={input.placeholder}
//                               name={input.fieldName}
//                               onChange={handleInputChange}
//                               required={input.fieldName !== "status"}
//                             />
//                           }
//                         </>
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default UnitNew;




import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { unitInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const UnitNew = ({ title }) => {
  const [inputValues, setInputValues] = useState({
    status: 0, // Default status to inactive
  });
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name || "");
    formData.append("month", inputValues.month || "");
    formData.append("description", inputValues.description || "");
    formData.append("chapter_id", localStorage.getItem("chapter_id_for_unit"));
    formData.append("status", inputValues.status);

    const toastId = toast.loading("Adding unit...");

    try {
      const response = await fetch(`${serverUrl}/add_unit`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        toast.update(toastId, {
          render: data.message || "Failed to add unit",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });

        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        }
      } else {
        toast.update(toastId, {
          render: "Unit added successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        setInputValues({
          status: 0,
        });

        setTimeout(() => {
          navigate("/teacher/course-chapter/unit");
        }, 1500);
      }
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Error occurred while adding unit",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {unitInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            {input.fieldName === "status" ? null : (
                              <>
                                <label>{input.label}</label>
                                <input
                                  type={input.type}
                                  placeholder={input.placeholder}
                                  name={input.fieldName}
                                  value={inputValues[input.fieldName] || ""}
                                  onChange={handleInputChange}
                                  required={input.fieldName !== "status"}
                                />
                              </>
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/teacher/course-chapter/unit")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Create Unit
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default UnitNew;